import {RouteConfig} from 'vue-router';
import ChallengerDetailDescription from '@/components/Challenges/tabs/description/ChallengerDetailDescription.vue';
import Timeline from '@/components/Challenges/tabs/timeline/Timeline.vue';
import ChallengeTeamsTab from '@/components/Challenges/tabs/teams/ChallengeTeamsTab.vue';
import TimelineTab from '@/components/Challenges/tabs/timeline/TimelineTab.vue';
import {challengeTeamsRouter} from '@/routes/challenge-teams.router';
import {challengeTimelineRouter} from '@/routes/challenge-timeline.router';
import ChallengerDetailCommunity from '@/components/Challenges/tabs/community/ChallengerDetailCommunity.vue';
import ChallengeFaqs from '@/components/Challenges/ChallengeFaqs.vue';
import ChallengerDetailJudges from '@/components/Challenges/tabs/judges/ChallengerDetailJudges.vue';
import ChallengerAdvisers from '@/components/Challenges/tabs/advisers/ChallengerAdvisers.vue';
import ChallengeForumTab from '@/components/Challenges/tabs/forum/ChallengeForumTab.vue';
import ChallengerDetailChallengeMap from '@/components/Challenges/tabs/ChallengerDetailChallengeMap.vue';
import ChallengeTasks from '@/components/Challenges/tabs/tasks/ChallengeTasks.vue';
import ChallengeDetailGallery from '@/components/Challenges/tabs/gallery/ChallengeDetailGallery.vue';
import ChallengeFiles from '@/components/Challenges/tabs/files/ChallengeFiles.vue';
import ChallengerDetailPartners from '@/components/Challenges/tabs/partners/ChallengerDetailPartners.vue';

export const challengeTabsRoutes: RouteConfig[] = [
  {
    path: '',
    name: 'challenge-description',
    component: ChallengerDetailDescription,
  },
  {
    path: 'timeline',
    component: TimelineTab,
    children: challengeTimelineRouter,
  },
  {
    path: 'teams',
    component: ChallengeTeamsTab,
    children: challengeTeamsRouter,
  },
  {
    path: 'community',
    name: 'challenge-community',
    component: ChallengerDetailCommunity,
  },
  {
    path: 'faq',
    name: 'challenge-faqs',
    component: ChallengeFaqs,
  },
  {
    path: 'judges',
    name: 'challenge-judges',
    component: ChallengerDetailJudges,
  },
  {
    path: 'advisers',
    name: 'challenge-advisers',
    component: ChallengerAdvisers,
  },
  {
    path: 'partners',
    name: 'challenge-partners',
    component: ChallengerDetailPartners,
  },
  {
    path: 'forum',
    name: 'challenge-forum',
    component: ChallengeForumTab,
  },
  {
    path: 'map',
    name: 'challenge-map',
    component: ChallengerDetailChallengeMap,
  },
  {
    path: 'tasks',
    name: 'challenge-tasks',
    component: ChallengeTasks,
  },
  {
    path: 'gallery',
    name: 'challenge-gallery',
    component: ChallengeDetailGallery
  },
  {
    path: 'files',
    name: 'challenge-files',
    component: ChallengeFiles
  }
];
